import Repository from '../Repository';

export default {

    getLmsEvents(pageSize, pageNumber, searchString, searchPaperIdString, searchMarkerRoleString, searchUserIdentityString, failedEventsOnly) {
		let payLoad = {params: {}};

		if(failedEventsOnly)
			payLoad.params = {pageSize: pageSize,
				pageNumber: pageNumber,
				SearchString: searchString,
				PaperId: searchPaperIdString ? Number(searchPaperIdString): null,
				MarkerRole: searchMarkerRoleString,
				PaperUserIdentity: searchUserIdentityString,
				isActive: true,
				orderDirection: 'desc',
				SortBy: 'createTime',
				failedEventsOnly: failedEventsOnly,
			}
		else
			payLoad.params = { 
				pageSize: pageSize,
				pageNumber: pageNumber,
				SearchString: searchString,
				PaperId: searchPaperIdString ? Number(searchPaperIdString): null,
				MarkerRole: searchMarkerRoleString,
				PaperUserIdentity: searchUserIdentityString,
				isActive: true,
				orderDirection: 'desc',
				SortBy: 'createTime', 
			}
		let response = Repository.get('Lms/GetLmsEvents', payLoad);
		return response;
	},

	retryMarkPush(paperId) {
		let payLoad = { paperId : paperId }
		let response = Repository.put('Lms/RetryMarkPush', payLoad);
		return response;
	},

	updateLmsEvent(auditLmsEventId, resolved, reason) {
		let payLoad = { 
			auditLmsEventId : auditLmsEventId,
			resolved: resolved,
			reason: reason
		}
		let response = Repository.put('Lms/UpdateLmsEvent', payLoad);
		return response;
	},

	deleteLmsJob(itemID) {
		let response = Repository.delete('Lms/DeleteLmsJob', {
			params: {		
				jobId: itemID, 
			}
		});
		return response;		
	},
}
